export type MediaKind = 'image' | 'audio' | 'video' | 'document';

const mimeByExtension: Record<string, string> = {
  jpg: 'image/jpeg', jpeg: 'image/jpeg', jpe: 'image/jpeg', png: 'image/png',
  gif: 'image/gif', webp: 'image/webp', bmp: 'image/bmp',
  heic: 'image/heic', heif: 'image/heif',
  ogg: 'audio/ogg', oga: 'audio/ogg', opus: 'audio/ogg', mp3: 'audio/mpeg',
  m4a: 'audio/mp4', aac: 'audio/aac', amr: 'audio/amr', wav: 'audio/wav',
  mp4: 'video/mp4', '3gp': 'video/3gpp', webm: 'video/webm', mov: 'video/quicktime',
  pdf: 'application/pdf'
};

export function mediaInfo(file: { url?: string | null; mimeType?: string | null; mediaKind?: string | null }) {
  let path = (file.url || '').split(/[?#]/)[0];
  try { path = decodeURIComponent(path); } catch { /* Keep malformed legacy URLs usable. */ }
  let mimeType = file.mimeType?.trim() || '';
  if (!mimeType || mimeType.toLowerCase() === 'application/octet-stream') {
    mimeType = mimeByExtension[path.split('.').pop()!.toLowerCase()] || mimeType || 'application/octet-stream';
  }
  const baseType = mimeType.split(';')[0].trim().toLowerCase();
  const storedKind = file.mediaKind?.trim().toLowerCase();
  const prefix = baseType.split('/')[0];
  const kind = (['image', 'audio', 'video', 'document'].includes(storedKind || '')
    ? storedKind : ['image', 'audio', 'video'].includes(prefix) ? prefix : 'document') as MediaKind;
  return { kind, mimeType, isPdf: baseType === 'application/pdf' };
}

export function isIncidentDocument(file: Parameters<typeof mediaInfo>[0]): boolean {
  return ['image', 'document'].includes(mediaInfo(file).kind);
}
